<template>
  <div>
    <form >
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="nome">Nome</label>
              <input type="text" class="form-control" id="nome" disabled v-model="data.nome">
            </div>
          </div>

          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="email">E-mail</label>
              <input type="text" class="form-control" id="email" disabled v-model="data.email">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="telefone">Telefone</label>
              <input type="text" class="form-control" id="telefone" disabled v-model="data.telefone">
            </div>
          </div>

          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="expectativa">Remuneração para menos de 10 horas de serviço</label>
              <input type="text" class="form-control" id="expectativa" disabled v-model="data.remuneracaoMenos10">
            </div>
          </div>
        </div>
        
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="habilidades">Habilidades (descrição)</label>
              <textarea type="text" class="form-control" id="habilidades" rows="3" disabled v-model="data.habilidades"></textarea>
            </div>
          </div> 
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="experiencia">Experiência (descrição)</label>
              <textarea type="text" class="form-control" id="experiencia" rows="3" disabled v-model="data.experiencia"></textarea>
            </div>
          </div> 
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="qualidades">Referências (Contatos que podem dar recomendações profissionais)</label>
              <textarea type="text" class="form-control" id="qualidades" rows="3" disabled v-model="data.referencias"></textarea>
            </div>
          </div> 
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="qualidades">Qualidades (O que você considera mais importante em você)</label>
              <textarea type="text" class="form-control" id="qualidades" rows="3" disabled v-model="data.qualidades"></textarea>
            </div>
          </div> 
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="limitacoes">Limitações</label>
              <textarea type="text" class="form-control" id="limitacoes" rows="3" disabled v-model="data.limitacoes"></textarea>
            </div>
          </div> 
        </div>

      </div>
    </form>
      
  </div>
</template>

<script>

export default {
  props: ['data'],
  name: 'Canoa',
  data () {
    return {
     
    }
  },
  components:{
   

  },
  
  methods: {
   
  },

  mounted () {
    
  },
  watch:  {
   
  }
}
</script>







// WEBPACK FOOTER //
// src/components/SalaCanoa/CanoaModal.vue